/**
 * Tiny boundary parsers for record data and command results (parse, don't validate).
 * TODO(contracts): generated validators from the feature CDDL replace these.
 */
export type Obj = Readonly<Record<string, unknown>>;

export const isObj = (v: unknown): v is Obj => typeof v === "object" && v !== null && !Array.isArray(v);
export const str = (v: unknown): string | null => (typeof v === "string" ? v : null);
export const num = (v: unknown): number | null => (typeof v === "number" && Number.isFinite(v) ? v : null);
/** Optional field: missing → undefined; present but wrong type → null (the record is rejected). */
export const opt = <T>(v: unknown, p: (v: unknown) => T | null): T | undefined | null => (v === undefined || v === null ? undefined : p(v));
/** Parses every element; one bad element rejects the array. */
export function arr<T>(v: unknown, p: (v: unknown) => T | null): T[] | null {
  if (!Array.isArray(v)) return null;
  const out: T[] = [];
  for (const x of v) {
    const y = p(x);
    if (y === null) return null;
    out.push(y);
  }
  return out;
}
